export const LOYALTY_LANDING_PAGE = 'societe'
export const LOYALTY_TERMS_AND_CONDITIONS_PAGE = 'societe-terms-and-conditions'
export const TASTE_OF_GOLD_DETAILS_PAGE = 'societe/taste-of-gold/details'
export const ESIM_DETAILS_PAGE = 'societe/esim/details'
export const ESIM_INFO_PAGE = 'societe/esim/info'
export const TIER_PROGRESSION_DETAILS_PAGE = 'societe/tier-progression/:highestTier'
export const TIER_UPGRADE_CAMPAIGN_PAGE = 'societe/:campaignSlug'
